import { useState, useEffect, useMemo } from "react";
import { Checkbox, Form, Input, Select } from "antd";
import { TermsAggreed } from "..";
import { USER_TYPES, useUserTypes } from "./config";
import { filterSelectOptions } from "../../../components/DynamicFormNew/helper";
import { filterOptions } from "../../../helpers/form";

export default function TifForm({
  onValuesChange = () => { },
  form,
  initialValues = {},
  displayError = () => { },
  t = (s) => s,
  step = 0,
  registrationData,
  organisation,
  setOrganisation = () => { },
  categories = [],
  showInputs = false,
  subCategories = [],
  economicSectorOptions = [],
  positionInSupplyChain = [],
  countries = [],
  code,
  termsAgreed,
  setTermsAgreed = () => { },
  registrationOptions = {},
}) {
  const [userType, setUserType] = useState(false);
  const allUserTYpes = useUserTypes();
  const isFlowA = userType === USER_TYPES.MINING_PRODUCER || userType === USER_TYPES.BUYER_MINERALS;
  const isFlowC = userType === USER_TYPES.PROGRAM_PARTNER || userType === USER_TYPES.PROGRAM_ASSESSOR;

  useEffect(() => {
    if (registrationData?.userType) {
      setUserType(registrationData.userType);
    }
    if (registrationData?.category) {
      setOrganisation(registrationData.category)
    }
  }, [registrationData])

  const userTypes = useMemo(() => {
    if (Array.isArray(registrationData?.allowedUserTypes) && registrationData.allowedUserTypes.length) {
      return allUserTYpes.filter(t => registrationData.allowedUserTypes.includes(t.value));
    }
    return allUserTYpes;
  }, [registrationData, allUserTYpes])

  return (
    <Form
      name="register"
      autoComplete="new-password"
      layout="vertical"
      form={form}
      initialValues={initialValues}
      onValuesChange={onValuesChange}
    >
      <Form.Item
        required
        name="firstName"
        {...displayError('firstName')}
        // hasFeedback
        label={t("Login::Name")}
        rules={[{
          required: true,
          message: t("errors::field is required")
        }]}
        hidden={step !== 0}
      >
        <Input size="large" type="text" placeholder={t("Login::NameP")}></Input>
      </Form.Item>
      <Form.Item
        required
        name="lastName"
        {...displayError('lastName')}
        label={t("Login::Last Name")}
        // hasFeedback
        hidden={step !== 0}
        rules={[{
          required: true,
          message: t("errors::field is required")
        }]}>
        <Input size="large" type="text" placeholder={t("Login::Last NameP")}></Input>
      </Form.Item>
      <Form.Item
        required
        name="email"
        label={t("Email")}
        {...displayError('email')}
        hidden={step !== 0}
        rules={[
          {
            pattern: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
            message: t('errors::email is not valid'),
          },
          {
            required: true,
            message: t("errors::field is required")
          }]}
      >
        <Input
          disabled={!!registrationData}
          size="large"
          type="email"
          placeholder={t("Login::EmailP")}
        />
      </Form.Item>

      {/* Step 2 */}
      <Form.Item
        required
        name="userType"
        {...displayError('userType')}
        label={t("User type")}
        rules={[{
          required: step === 1,
          message: t("errors::field is required")
        }]}
        hidden={![1].includes(step)}
      >
        <Select
          onChange={(v) => {
            setUserType(v);
          }}
          autoComplete="new-password"
          size="large"
          showSearch
          disabled={code && userType === 'miningProducer'} // disabled for mamp
          filterOption={filterSelectOptions}
          optionFilterProp="children"
          placeholder={t("User type")}>
          {userTypes.map(cat =>
            <Select.Option key={cat.value}>
              {t(cat.label)}
            </Select.Option>
          )}
        </Select>
      </Form.Item>

      <Form.Item
        required
        hidden={(!isFlowA) || step !== 1}
        name="subCategory"
        {...displayError('subCategory')}
        label={t("Legal Form")}
        rules={[{
          required: isFlowA && step === 1,
          message: t("errors::field is required")
        }]}
      >
        <Select
          autoComplete="new-password"
          size="large"
          showSearch
          filterOption={filterSelectOptions}
          optionFilterProp="children"
          disabled={code && userType === 'miningProducer'} // disabled for mamp
          placeholder={t("Legal Form")}>
          {filterOptions(registrationOptions?.subCategory || [], ['stkCategory|category'], { category: 'corporation' })
            .map(option =>
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            )}
        </Select>
      </Form.Item>

      <Form.Item
        required
        // hasFeedback
        name="category"
        {...displayError('category')}
        label={t("User Category")}
        rules={[{
          required: step === 1 && isFlowC,
          message: t("errors::field is required")
        }]}
        hidden={![1].includes(step) || !isFlowC}
      >
        <Select
          className={!!organisation && 'top-select'}
          onChange={(v) => {
            setOrganisation(v);
          }}
          autoComplete="new-password"
          size="large"
          showSearch
          filterOption={filterSelectOptions}
          optionFilterProp="children"
          placeholder={t("User Category")}>
          {categories.map(cat =>
            <Select.Option key={cat.value}>
              {cat.label}
            </Select.Option>
          )}
        </Select>
      </Form.Item>
      <Form.Item
        required
        hidden={(!showInputs.subCategory || subCategories.length === 0) || step !== 1 || !isFlowC}
        name="subCategory"
        {...displayError('subCategory')}
        label={t("User sub category")}
        rules={[{
          required: !(!showInputs.subCategory || subCategories.length === 0) && step === 1 && isFlowC,
          message: t("errors::field is required")
        }]}
      >
        <Select
          autoComplete="new-password"
          size="large"
          showSearch
          filterOption={filterSelectOptions}
          optionFilterProp="children"
          placeholder={t("User sub category")}>
          {subCategories.map(option =>
            <Select.Option key={option.value} value={option.value}>
              {option.label}
            </Select.Option>
          )}
        </Select>
      </Form.Item>
      <Form.Item
        required
        hidden={!showInputs.economicSector || !!!organisation || step !== 1 || !isFlowC}
        name="economicSector"
        {...displayError('economicSector')}
        label={t("Economic sector")}
        rules={[{
          required: showInputs.economicSector && !!organisation && isFlowC && step === 1,
          message: t("errors::field is required")
        }]}>
        <Select
          autoComplete="new-password"
          size="large"
          showSearch
          filterOption={filterSelectOptions}
          optionFilterProp="children"
          placeholder={t("Economic sector")}>
          {economicSectorOptions.map(option =>
            <Select.Option key={option.value} value={option.value}>
              {option.label}
            </Select.Option>
          )}
        </Select>
      </Form.Item>
      <Form.Item
        required
        hidden={!showInputs.positionInSupplyChain || !!!organisation || step !== 1 || !isFlowC}
        name="positionInTheMineralSupplyChain"
        {...displayError('positionInTheMineralSupplyChain')}
        label={t("positionInTheMineralSupplyChain")}
        rules={[{
          required: showInputs.positionInSupplyChain && !!organisation && isFlowC,
          message: t("errors::field is required")
        }]}>
        <Select
          autoComplete="new-password"
          mode="multiple"
          size="large"
          showSearch
          filterOption={filterSelectOptions}
          optionFilterProp="children"
          placeholder={t("positionInTheMineralSupplyChain")}>
          {positionInSupplyChain.map(option =>
            <Select.Option key={option.value} value={option.value}>
              {option.label}
            </Select.Option>
          )}
        </Select>
      </Form.Item>
      <Form.Item
        required
        hidden={
          (isFlowA) ? step !== 1 : (!showInputs.name || !!!organisation || step !== 1 || !isFlowC)
        }
        {...displayError('name')}
        // hasFeedback
        name="name"
        label={t('Organisation common name')}
        rules={[{
          required: (isFlowA) ? step === 1 : (showInputs.name && !!organisation && isFlowC && step === 1),
          message: t("errors::field is required")
        }]}>
        <Input
          disabled={code && userType === 'miningProducer'} // disabled for mamp
          size="large"
          type="text"
          placeholder={t('Organisation common name')}
        />
      </Form.Item>
      <Form.Item
        required
        hidden={!(organisation || isFlowA) || step !== 1}
        // hasFeedback
        name="country"
        {...displayError('country')}
        label={showInputs.name ? t('Registration country') : t("Country")}
        rules={[{
          required: (organisation || isFlowA) && step === 1,
          message: t("errors::field is required")
        }]}>
        <Select
          autoComplete="new-password"
          size="large"
          showSearch
          disabled={code && userType === 'miningProducer'} // disabled for mamp
          filterOption={filterSelectOptions}
          optionFilterProp="children"
          placeholder={showInputs.name ? t('Registration country') : t("Country")}>
          {countries.map(country =>
            <Select.Option key={country.value}>
              {country.label}
            </Select.Option>
          )}
        </Select>
      </Form.Item>

      {/* Step 3 */}
      <Form.Item
        required
        name="password"
        {...displayError('password')}
        label={t("Enter password")}
        hidden={step !== 2}
        // hasFeedback
        rules={[{
          required: step === 2,
          message: t("errors::field is required")
        }]}>
        <Input.Password
          size="large"
          placeholder="••••••••" />
      </Form.Item>
      <Form.Item
        required
        name="confirmPassword"
        {...displayError('confirmPassword')}
        label={t("Confirm password")}
        // hasFeedback
        dependencies={['password']}
        hidden={step !== 2}
        rules={[
          {
            required: step === 2,
            message: t("errors::field is required"),
          },
          ({ getFieldValue }) => ({
            validator(rule, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject(t('errors::passwordNotMatch'));
            },
          }),
        ]}>
        <Input.Password
          size="large"
          placeholder="••••••••" />
      </Form.Item>
      <Form.Item
        hidden={step !== 2}
        name="mailUpdates" valuePropName="checked" noStyle>
        <Checkbox>{t("Sign up to receive updates")}</Checkbox>
      </Form.Item>
      <Form.Item
        hidden={step !== 2}
        name="agreeTerms" valuePropName="checked" noStyle>
        <TermsAggreed
          termsAgreed={termsAgreed}
          setTermsAgreed={setTermsAgreed}
          t={t}
        />
      </Form.Item>
    </Form>
  )
}
